import { Parameter } from "domain/entities/parameter";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";

const StatusProjectDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
}> = ({ options }) => {
  const [ProjectStatusOptions, setProjectStatusOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const { projectStatus, setProjectStatus } = useParameterStore();

  const { data: parameters } = useParameterByFilter({
    limit: 1000,
    sortBy: "value",
  } as BaseInputFilter);

  useEffect(() => {
    setProjectStatus(
      parameters?.data?.filter((item) => item.type === "projectStatus")
    );
  }, [parameters]);

  useEffect(() => {
    setProjectStatusOptions(
      projectStatus.map((item: Parameter) => ({
        label: item.value,
        value: item.value === "Ativo" ? "true" : "false",
      }))
    );
  }, [projectStatus]);

  return (
    <Dropdown
      value={options.value}
      options={ProjectStatusOptions}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione o status"
      showClear
    />
  );
};
export default StatusProjectDropdown;
